// Salesforce Opportunity dependencies (2026-09-28): category -> country -> destination -> sub-destinations.
// Labels match Salesforce exactly.
export type LocationTree = { [option: string]: LocationTree } | Array<string>;

export const LOCATION_OPTIONS: LocationTree = {
  Africa: {
    Botswana: {},
    'Canary Islands': {},
    'Cape Verde': {},
    Ethiopia: {},
    Kenya: {},
    Lesotho: {
      Maseru: [],
    },
    Madagascar: {},
    Mauritius: {},
    Morocco: {},
    Mozambique: {
      'Bazaruto Island': [],
      Medjumbe: [],
      'Pemba Beach': [],
    },
    Namibia: {
      Windhoek: [],
    },
    Reunion: {},
    Seychelles: {},
    'South Africa': {},
    Tanzania: {},
    Tunisia: {},
    Uganda: {},
    Zambia: {
      Livingstone: [],
    },
    Zimbabwe: {},
  },
  Australasia: {
    Australia: {
      'Australian Capital Territory': ['Canberra'],
      'New South Wales': [
        'Ballina',
        'Blue Mountains',
        'Byron Bay',
        'Hunter Valley',
        'Port Stephens',
        'Snowy Mountains',
        'Southern Highlands',
        'Sydney',
        'Yamba',
        'Central Coast',
        'Newcastle Area',
        'North Coast',
        'Tweed Coast',
        'Shoalhaven',
        'Other',
      ],
      'Northern Territory': ['Ayers Rock', 'Darwin'],
      Queensland: [
        'Brisbane',
        'Cairns',
        'Gold Coast',
        'Noosa',
        'Palm Cove',
        'Port Douglas',
        'Sunshine Coast',
        'Whitsundays',
        'Queensland Islands',
      ],
      'South Australia': ['Adelaide', 'Barossa Valley', 'McLaren Vale', 'Kangaroo Island'],
      Tasmania: [],
      Victoria: [
        'Dandenong',
        'Daylesford',
        'Lorne',
        'Melbourne',
        'Mornington Peninsula',
        'Phillip Island',
        'Yarra Valley',
        'Gippsland',
        'Daylesford/Hepburn',
        'Bellarine',
        'Great Ocean Road',
        'Grampians',
        'Other',
      ],
      'Western Australia': ['Broome', 'Margaret River', 'Perth'],
      'Central Queensland': [],
      'Darling Downs South West': [],
      'Far North Queensland': [],
      'Mackay Isaac Whitsunday': [],
      'North Queensland': [],
      'North West Queensland': [],
      'South East Queensland North': [],
      'South East Queensland South': [],
      'Southeast Queensland West': [],
      'Wide Bay Burnett': [],
    },
    'New Zealand': {
      'North Island': ['Bay Of Islands', 'Wellington', 'Auckland', 'North Island Regional'],
      'South Island': ['Queenstown', 'Christchurch', 'South Island Regional'],
    },
    Palau: {},
    'Papua New Guinea': {},
  },
  Carribean: {
    Antigua: {},
    Aruba: {},
    Barbados: {},
    'British Virgin Islands': {},
    'Cayman Islands': {},
    Cuba: {},
    Curacao: {},
    'Dominican Republic': {},
    Jamaica: {},
    'Puerto Rico': {},
    'Saint Lucia': {},
    'Saint Martin': {},
    'St Johns': {},
    'The Bahamas': {},
    'Turks and Caicos': {},
    'US Virgin Islands': {},
  },
  'East Asia': {
    China: {
      Beijing: [],
      Chhattisgarh: [],
      Shanghai: [],
      'Yasawa Islands': [],
      Xishuangbanna: [],
      Chengdu: [],
      Hangzhou: [],
      Suzhou: [],
      Huzhou: [],
      Xian: [],
      Guangzhou: [],
      Nanjing: [],
      Sanya: [],
      Changshu: [],
      Changzhou: [],
      Wuxi: [],
      Yangzhou: [],
      Wuhan: [],
      Guiyang: [],
      Xiamen: [],
      Shenzhen: [],
      Yunnan: [],
      Qingdao: [],
      DalianNingbo: [],
      Tianjin: [],
      Zhangjiajie: [],
      Guilin: [],
    },
    'Hong Kong': {},
    Japan: {},
    Kazakhstan: {},
    Mongolia: {},
    'South Korea': {},
    Taiwan: {},
  },
  Europe: {
    Austria: {},
    Belgium: {
      Brussels: [],
      Hasselt: [],
    },
    Croatia: {},
    Cyprus: {},
    Denmark: {},
    Finland: {},
    France: {
      Ain: [],
      Bordeaux: [],
      Cannes: [],
      'Chailly-Sur-Armancon': [],
      Marseille: [],
      Occitanie: [],
      Paris: [],
      'Saint Paul de Vence': [],
      Strasbourg: [],
    },
    Germany: {
      Berlin: [],
    },
    Greece: {
      Andros: [],
      Athens: [],
      'Continental Greece': [],
      Corfu: [],
      Crete: [],
      'Greek Islands': [],
      Kefalonia: [],
      Kos: [],
      Lemnos: [],
      Mykonos: [],
      Paros: [],
      Santorini: [],
    },
    Iceland: {
      Reykjavik: [],
    },
    Ireland: {},
    Italy: {
      Florence: [],
      Milan: [],
      Rome: [],
      Venice: [],
    },
    Malta: {},
    Montenegro: {},
    Netherlands: {
      Amsterdam: [],
    },
    Norway: {},
    Portugal: {},
    Spain: {
      Barcelona: [],
      'Costa Brava': [],
      Madrid: [],
      Malaga: [],
      Mallorca: [],
      Tenerife: [],
      Alicante: [],
      Valencia: [],
      Seville: [],
      Salamanca: [],
      Caceres: [],
      Corboda: [],
      Granada: [],
      Ibiza: [],
    },
    Sweden: {},
    Switzerland: {},
    'United Kingdom': {
      Cotswolds: [],
      Edinburgh: [],
      'Lake District': [],
      London: [],
      BUCKINGHAMSHIRE: [],
      Devon: [],
      Cornwall: [],
      Bath: [],
      Sussex: [],
    },
  },
  'Eastern Europe': {
    'Czech Republic': {
      Prague: [],
    },
    Hungary: {
      Budapest: [],
    },
    Poland: {},
    Russia: {},
  },
  'Middle East': {
    Azerbaijan: {},
    Egypt: {},
    Israel: {},
    Jordan: {},
    Kuwait: {},
    Lebanon: {},
    Oman: {},
    Qatar: {},
    'Saudi Arabia': {},
    Turkey: {
      Belek: [],
      Istanbul: [],
    },
    'United Arab Emirates': {
      'Abu Dhabi': [],
      Dubai: [],
      'Ras Al Khaimah': [],
    },
    Uzbekistan: {},
  },
  'North America': {
    Canada: {
      Alberta: ['Edmonton', 'Calgary'],
      'British Columbia': ['Vancouver', 'Victoria'],
      Manitoba: ['Winnipeg'],
      'New Brunswick': ['Fredericton', 'Moncton'],
      'New Foundland and Labrador': ["St. John's"],
      'Nova Scotia': ['Halifax'],
      Ontario: ['Toronto'],
      'Prince Edward Island': ['Charlottetown'],
      Quebec: ['Montreal', 'Quebec City'],
      Saskatchewan: ['Saskatoon', 'Regina'],
      Whistler: [],
      Rockies: [],
    },
    Mexico: {
      'Los Cabos': [],
      Cancun: [],
      'Puerta Vallarta': [],
    },
    'United States': {
      Hawaii: ['Big Island', 'Maui', 'Oahu', 'Kauai', 'Lanai'],
      'New York': [],
      'Washington DC': [],
      Alabama: [],
      Alaska: [],
      Arizona: [],
      Arkansas: [],
      California: [
        'Los Angeles',
        'San Francisco',
        'Santa Monica',
        'Anaheim',
        'Wine Country',
        'California Beaches',
        'San Diego',
        'Palm Springs',
      ],
      Colorado: [],
      Connecticut: [],
      Delaware: [],
      Florida: ['Miami'],
      Georgia: [],
      Idaho: [],
      Illinois: ['Chicago'],
      Indiana: [],
      Iowa: [],
      Kansas: [],
      Kentucky: [],
      Louisiana: ['Las Vegas'],
      Maine: [],
      Maryland: [],
      Massachusetts: [],
      Michigan: [],
      Minnesota: [],
      Mississippi: [],
      Missouri: [],
      Montana: [],
      Nebraska: [],
      Nevada: ['Las Vegas'],
      'New Hampshire': [],
      'New Jersey': [],
      'New Mexico': [],
      'North Carolina': [],
      'North Dakota': [],
      Ohio: [],
      Oklahoma: [],
      Oregon: [],
      Pennsylvania: [],
      'Rhode Island': [],
      'South Carolina': [],
      'South Dakota': [],
      Tennessee: ['Miami'],
      Texas: ['Houston', 'Dallas', 'San Antonio', 'Austin'],
      Utah: [],
      Vermont: [],
      Virginia: [],
      Washington: ['Seattle'],
      'West Virginia': [],
      Wisconsin: [],
      Wyoming: [],
    },
  },
  'Central America': {
    Belize: {},
    'Costa Rica': {},
    'El Salvador': {},
    Guatemala: {},
    Honduras: {},
    Nicaragua: {},
    Panama: {},
  },
  'South America': {
    Argentina: {},
    Bolivia: {},
    Brazil: {},
    Chile: {},
    Colombia: {},
    Ecuador: {},
    'Falkland Islands': {},
    Paraguay: {},
    Peru: {},
    Uruguay: {},
  },
  'South Asia': {
    Bhutan: {},
    India: {
      'Andaman and Nicobar Islands': [],
      'Andhra Pradesh': [],
      'Arunachal Pradesh': [],
      Assam: [],
      Bihar: [],
      Chandigarh: [],
      Chhattisgarh: [],
      'Dadra and Nagar Haveli': [],
      'Daman and Diu': [],
      Delhi: [],
      Goa: [],
      Gujarat: [],
      Haryana: [],
      'Himachal Pradesh': [],
      'Jammu and Kashmir': [],
      Jharkhand: [],
      Karnataka: [],
      Kerala: [],
      Lakshadweep: ['New Delhi'],
      'Madhya Pradesh': [],
      Maharashtra: ['Mumbai'],
      Manipur: [],
      Meghalaya: [],
      Mizoram: [],
      Nagaland: [],
      Odisha: [],
      Puducherry: [],
      Punjab: [],
      Rajasthan: [],
      Sikkim: [],
      'Tamil Nadu': [],
      Telangana: ['Bikaner', 'Hyderabad'],
      Tripura: [],
      Uttarakhand: [],
      'Uttar Pradesh': [],
      'West Bengal': [],
      Bodhgaya: [],
    },
    Maldives: {},
    Nepal: {},
  },
  'South East Asia': {
    Brunei: {},
    Cambodia: {
      'Phnom Penh': [],
      'Siem Reap': [],
    },
    Indonesia: {
      Bali: ['Jimbaran', 'Legian', 'Nusa Dua', 'Sanur', 'Seminyak', 'Ubud', 'Canggu', 'Uluwatu', 'Menjangan'],
      Lombok: [],
      'Gili Trawangan': [],
      'Nusa Lembongan': [],
      Batam: ['Nongsa'],
      Bintan: [],
    },
    Laos: {},
    Malaysia: {
      Borneo: [],
      'Kuala Lumpur': [],
      Langkawi: [],
      Penang: [],
      Desaru: [],
      Sepang: [],
    },
    Myanmar: {},
    Philippines: {},
    Singapore: {},
    'Sri Lanka': {},
    Thailand: {
      Bangkok: [],
      'Chiang Mai': [],
      'Hua Hin': [],
      'Koh Phangan': [],
      'Koh Samui': [],
      Krabi: [],
      Phuket: ['Khao Lak', 'Patong', 'Karon', 'Mai Khao'],
      'Khao Lak': [],
      Pattaya: [],
      'Chiang Rai': [],
      'Khon Kaen': [],
    },
    Vietnam: {
      'Con Dao': [],
      'Da Nang': [],
      'Halong Bay': [],
      Hanoi: [],
      'Ho Chi Minh City': [],
      'Hoi An': [],
      'Nha Trang': [],
      'Phu Quoc': [],
      'Hai Phong': [],
      'Mui Ne': [],
      'Quy Nhon': [],
    },
  },
  'South Pacific': {
    'Cook Islands': {
      Aitutaki: [],
      Rarotonga: [],
    },
    'Easter Island': {},
    Fiji: {
      Mamanucas: [],
      Denarau: [],
      'Yasawa Islands': [],
      'Coral Coast': [],
      Taveuni: [],
      Savusavu: [],
      'Pacific Harbour': [],
    },
    'French Polynesia': {},
    'New Caledonia': {},
    Samoa: {},
    'Solomon Islands': {},
    Tonga: {},
    Vanuatu: {},
  },
};
